import { render, staticRenderFns } from "./SelectSurveyPage.vue?vue&type=template&id=84236486&scoped=true&"
import script from "./SelectSurveyPage.vue?vue&type=script&lang=js&"
export * from "./SelectSurveyPage.vue?vue&type=script&lang=js&"
import style0 from "./SelectSurveyPage.vue?vue&type=style&index=0&id=84236486&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84236486",
  null
  
)

export default component.exports